import { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Import Components
import ActivityKPI from 'components/common/ActivityKPI';
import CustomerJourneyProgressData from './CustomerJourneyProgressData';
// Import Hooks
import useRequest from 'hooks/UseRequest';
import useCancelableRequests from 'hooks/UseCancelableRequests';
// Import Constants
import { l, PromotionTypeLabels } from 'constants/common';
// Import Services
import { CommunicationHttpService } from 'services/http';

const CustomerJourneyProgress = ({ workflowId, promotionType }) => {
    const { doPostRequest } = useRequest();

    const [isLoadingWorkflowReport, setIsLoadingWorkflowReport] = useState(false);
    const [workflowKPIs, setWorkflowKPIs] = useState({});
    const [workflowReportData, setWorkflowReportData] = useState(null);

    const { getPromotionGeneralReport } = useCancelableRequests({
        getPromotionGeneralReport: CommunicationHttpService.getPromotionGeneralReport,
    });

    const isCJ = promotionType === +PromotionTypeLabels.CustomerJourney;

    useEffect(() => {
        setIsLoadingWorkflowReport(true);
        const requestBody = {
            PromotionId: workflowId,
            CampaignType: promotionType,
        };
        doPostRequest(getPromotionGeneralReport.request, {
            requestBody,
            successCallback: ({
                Data,
                Total,
                Sent,
                TotalOpened,
                TotalClicked,
                TotalUnsubscribed,
                TotalClickUnsubscribed,
            }) => {
                setWorkflowReportData(Data);
                setWorkflowKPIs({
                    total: Total,
                    sendCount: Sent,
                    openCount: TotalOpened,
                    clickCount: TotalClicked,
                    unsubscribeCount: TotalUnsubscribed,
                    clickUnsubscribeCount: TotalClickUnsubscribed,
                });
            },
        }).then(() => {
            setIsLoadingWorkflowReport(false);
        });
    }, [workflowId, promotionType, doPostRequest, getPromotionGeneralReport]);

    return (
        <div className="details-page-wrapper c-j-report-grand-wrapper">
            <ActivityKPI
                isLoading={isLoadingWorkflowReport}
                data={workflowKPIs}
                title={isCJ ? l.CustomerJourneyKPIs : l.ActionCampaignKPIs}
            />
            <CustomerJourneyProgressData
                reportData={workflowReportData}
                isLoadingReport={isLoadingWorkflowReport}
                workflowId={workflowId}
                promotionType={promotionType}
            />
        </div>
    );
};

CustomerJourneyProgress.propTypes = {
    workflowId: PropTypes.string.isRequired,
    promotionType: PropTypes.number.isRequired,
};

export default memo(CustomerJourneyProgress);
